// src/utils.js
import React from 'react';
import { ImageIcon, Clapperboard } from 'lucide-react';

// 计算图片/视频的缩放尺寸（保持比例，短边固定）
export const calculateFixedShortSide = (imgWidth, imgHeight, shortSideValue = 180) => {
  if (!imgWidth || !imgHeight) return { width: 240, height: 150 }; 
  if (imgWidth >= imgHeight) return { width: (imgWidth / imgHeight) * shortSideValue, height: shortSideValue };
  return { width: shortSideValue, height: (imgHeight / imgWidth) * shortSideValue };
};

// 从 URL 中提取文件名（用于跨域/CDN URL 比较）
export const getFilename = (url) => {
  if (!url) return '';
  try {
    const pathname = new URL(url).pathname;
    return pathname.split('/').pop() || pathname;
  } catch {
    return url.split('/').pop()?.split('?')[0] || url;
  }
};

// 获取连接推荐菜单数据
export const getRecommendations = (data) => {
  const allItems = [
    { title: "图像模型", desc: "通用的图像生成模型", icon: <ImageIcon size={14}/>, types: ['text', 'image'] },
    { title: "视频模型", desc: "通用的视频生成模型", icon: <Clapperboard size={14}/>, types: ['text', 'image'] },
  ];

  // 如果源头是音频或视频，过滤掉“图像模型”
  if (data?.sourceType === 'audio' || data?.sourceType === 'video') {
    return allItems.filter(item => item.title !== "图像模型");
  }

  return allItems;
};